@use "../../../../../../styles/Constants.scss" as Constants;
@use "../../../../../../styles/Colors.scss" as Colors;

.MaterialGroups {
	margin-top: Constants.$val-spacing-s;
	padding: Constants.$val-spacing-m;

	.titleActions {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		margin-bottom: Constants.$val-spacing-m;

		.title {
			color: Colors.$col-design-grey10;
			text-transform: uppercase;
			font-size: Constants.$val-fontSizeSmall;
			line-height: Constants.$val-lineHeightSmall;
		}

		.actions {
			display: flex;
			align-items: center;
			justify-content: flex-end;

			.action {
				margin-left: Constants.$val-spacing-m;
			}
		}
	}
}
